import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  input,
  OnChanges,
  output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiButtonComponent, QaiDialogComponent } from '@qai/ui';

@Component({
  selector: 'leave-confirmation-modal',
  standalone: true,
  templateUrl: './leave-confirmation-modal.component.html',
  styleUrls: ['./leave-confirmation-modal.component.scss'],
  imports: [FormsModule, CommonModule, QaiDialogComponent, QaiButtonComponent, TranslocoModule],
})
export class LeaveConfirmationModalComponent implements OnChanges {
  @ViewChild('leaveConfirmationDialog') dialogRef: QaiDialogComponent | undefined;

  open = input<boolean>(false);
  networkRequestInProgress = input<boolean>(false);

  openChange = output<boolean>();
  confirm = output<void>();
  closeModal = output<void>();
  private isClosing = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.updateModalState();
  }

  handleLeave(): void {
    this.confirm.emit();
  }

  handleClose(): void {
    this.setClosedState();
  }

  private updateModalState(): void {
    if (this.open()) {
      this.dialogRef?.showModal();
    } else {
      this.dialogRef?.close();
    }
  }

  private setClosedState(): void {
    if (!this.open() || this.isClosing) {
      return;
    }

    this.isClosing = true;
    this.closeModal.emit();
    this.dialogRef?.close();
    this.openChange.emit(false);
    this.cdRef.detectChanges();
    this.isClosing = false;
  }
}
